import { useEffect, useMemo, useState } from "react";
import { Polyline } from "react-leaflet";
import { DomEvent } from "leaflet";

import { Typography } from "@mui/material";

import { ROUTE_SIZE, STATIONS_COLOR } from "Configs/map";
import { OperationNames } from "Types/operation";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import { createPoint, setPoints } from "Redux/pointsSlice";
import { setDistance } from "Redux/stationsSlice";

import { getRouteCoordinates } from "Helper/map";

import HintBox from "Components/HintBox";

export default function Route() {
  const dispatch = useAppDispatch();

  const { stations } = useAppSelector((state) => state.stations);
  const { points } = useAppSelector((state) => state.points);
  const { type, name } = useAppSelector((state) => state.operation);

  const [showHint, setShowHint] = useState<boolean>(false);
  const [hoveredLine, setHoveredLine] = useState<number | null>(null);

  const routeColor: string = type ? STATIONS_COLOR[type] : "";

  const renderPolyline = useMemo(() => {
    const newPoints = [];
    for (let i = 0; i + 1 < points.length; i += 1) {
      newPoints.push(points.slice(i, i + 2));
    }

    return newPoints.map((point, index) => {
      const polylinePoints: [number, number][] = point.map((i) => [i.lat, i.lng]);

      return (
        <>
          <Polyline
            positions={polylinePoints}
            pathOptions={{
              color: routeColor,
              weight: ROUTE_SIZE,
              opacity: hoveredLine === null || hoveredLine === index ? 1 : 0.3,
            }}
          />
          <Polyline
            positions={polylinePoints}
            pathOptions={{ color: "transparent", weight: ROUTE_SIZE * 3 }}
            eventHandlers={{
              click: (e) => {
                DomEvent.stopPropagation(e);

                const { lat, lng } = e.latlng;
                dispatch(createPoint({ point: { lat, lng }, order: index }));
              },
              mouseover: (e) => {
                setShowHint(true);
                setHoveredLine(index);
              },
              mouseout: () => {
                setShowHint(false);
                setHoveredLine(null);
              },
            }}
          />
        </>
      );
    });
  }, [points, routeColor, hoveredLine]);

  useEffect(() => {
    const operationNames: OperationNames[] = ["create-path", "edit-path"];
    if (name !== null && operationNames.includes(name)) {
      getRouteCoordinates(stations).then((res) => {
        dispatch(setPoints(res.result));
        dispatch(setDistance(res.distance));
      });
    }
  }, [stations]);

  return (
    <>
      {renderPolyline}

      <HintBox visible={showHint}>
        <Typography sx={{ m: "0 !important" }}>برای ایجاد نقطه کلیک کنید</Typography>
      </HintBox>
    </>
  );
}
